<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button content="menu.directionMaintain" mode="text" status="primary"/>
      </template>
      <template #extra>
        <vxe-button content="button.refresh" icon="vxe-icon-refresh" mode="text" status="danger" @click="refresh(direction)"/>
        <vxe-button content="button.add" icon="vxe-icon-add" mode="text" status="primary" @click="add"/>
      </template>
      <vxe-table ref="table" :data="list" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="dayOfWeek" title="business.label.dayOfWeek" width="150"/>
        <vxe-column field="ordinal" title="business.label.ordinal" width="300"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row,false)"/>
            <vxe-button content="button.copy" icon="vxe-icon-copy" status="primary" @click.stop="edit(row,true)"/>
            <vxe-button content="button.delete" icon="vxe-icon-delete" status="danger" @click.stop="remove(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
    </vxe-card>
    <vxe-modal v-model="visible" :loading="loading" title="menu.directionMaintain" type="confirm" width="40%" @confirm="confirm">
      <vxe-form ref="form" :data="config" :rules="rules" span="12">
        <vxe-form-item :item-render="{name:'VxeNumberInput'}" field="dayOfWeek" title="business.label.dayOfWeek"/>
        <vxe-form-item :item-render="{name:'VxeNumberInput'}" field="ordinal" title="business.label.ordinal"/>
      </vxe-form>
    </vxe-modal>
  </div>
</template>

<script>
import { deleteOne, findAll, findOne, save } from '@/api/Api'
import { Dictionary } from '@/api/dto/admin/Dictionary'
import { DirectionConfig } from '@/api/dto/config/DirectionConfig'

export default {
  data() {
    return {
      loading: false,
      visible: false,
      direction: new Dictionary(),
      list: [],
      config: new DirectionConfig(),
      rules: {
        dayOfWeek: [{ required: true, type: 'number', min: 1, message: this.$t('message.cannotBeEmpty') }],
        ordinal: [{ required: true, type: 'number', min: 1, message: this.$t('message.cannotBeEmpty') }]
      }
    }
  },
  methods: {
    refresh(direction) {
      this.direction = direction
      if (this.direction.isNew()) {
        return this.$message.warning('请先选择字典项')
      }
      this.loading = true
      findAll('directionConfigFactory', { 'direction.id': this.direction.id }).then(res => {
        if (res.success) {
          this.list = res.result.map(item => {
            return new DirectionConfig(item)
          })
        }
      }).finally(() => this.loading = false)
    },
    add() {
      this.visible = true
      this.config = new DirectionConfig()
    },
    edit(row, copy) {
      this.visible = true
      this.loading = true
      findOne('directionConfigFactory', { id: row.id }).then(res => {
        if (res.success) {
          if (copy) {
            res.result.id = undefined
            res.result.version = undefined
          }
          this.config = new DirectionConfig(res.result)
        }
      }).finally(() => this.loading = false)
    },
    save() {
      this.loading = true
      const config = this.config.toJSONObject()
      config.direction = this.direction
      save('directionConfigPersister', config).then(res => {
        if (res.success) {
          this.config = new DirectionConfig(res.result)
          this.$message.success(this.$t('message.saveSuccess'))
          this.refresh(this.direction)
          this.visible = false
        }
      }).finally(() => this.loading = false)
    },
    async confirm() {
      if (!await this.$refs.form.validate()) this.save()
    },
    remove(row) {
      if (row.id) {
        this.loading = true
        deleteOne('directionConfigDeleter', { id: row.id }).then(res => {
          if (res.success) {
            this.refresh(this.direction)
            this.$message.success(this.$t('message.deleteSuccess'))
          }
        }).finally(() => this.loading = false)
      } else {
        this.list.splice(this.list.indexOf(row), 1)
      }
    }
  }
}
</script>